// extracted by mini-css-extract-plugin
export default {"Modal":"ValidationErrorModal_Modal__WXm+w","Buttons":"ValidationErrorModal_Buttons__Ev-Pj","ErrorIcon":"ValidationErrorModal_ErrorIcon__HAl5X"};